import React, { Component } from "react";
import { Api } from "../utils/api";
import { withRouter } from "react-router";
import { Typography } from "@material-ui/core";
import EntityGroupElementsTable from "./components/entity_group_elements_table.component";
import Select from "@material-ui/core/Select";
import Button from "@material-ui/core/Button";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { Formik } from "formik";

class EntityGroupView extends Component {
  state = {
    entities_without_group: null,
    add_to_group: null,
    remove_from_group: null,
    entityGroupName: null,
    establishmentsList: null,
    entitiesList: null,
    showAlert: false,
    alertTitle: "",
    alertMessage: "",
  };

  constructor() {
    super();
    this.api = new Api();
    this.getEntities = this.getEntities.bind(this);
    this.getEntityGroup = this.getEntityGroup.bind(this);
    this.arrayAddEntities = this.arrayAddEntities.bind(this);
    this.addEntitiesToGroup = this.addEntitiesToGroup.bind(this);
    this.arrayRemoveEntities = this.arrayRemoveEntities.bind(this);
    this.removeEntitiesFromGroup = this.removeEntitiesFromGroup.bind(this);
    this.showAlert = this.showAlert.bind(this);
    this.closeAlert = this.closeAlert.bind(this);
  }

  componentDidMount() {
    let with_no_group = true;
    this.getEntities(with_no_group);
    this.getEntityGroup();
  }

  showAlert(title, message) {
    this.setState({ showAlert: true });
    this.setState({ alertTitle: title });
    this.setState({ alertMessage: message });
  }

  closeAlert() {
    this.setState({ showAlert: false });
  }

  //ir buscar a lista de entidades sem grupo associado
  getEntities(with_no_group) {
    this.api.get(`entities`, { with_no_group }).then(({ data = null }) => {
      this.setState({ entities_without_group: data });
    });
  }

  //Criar array de entidades a serem adicionadas ao grupo existente
  arrayAddEntities = (event, values) => {
    const oldarray = values;
    const newarray = [];
    for (let i = 0; i < oldarray.length; i++) {
      newarray.push(oldarray[i].id);
    }
    this.setState({
      add_to_group: newarray,
    });
  };

  //Método para adicionar entidades ao grupo existente
  addEntitiesToGroup = (data) => {
    if (data.add_to_group != null) {
      try {
        for (let i = 0; i < data.add_to_group.length; i++) {
          this.api.patch(`/entities/${data.add_to_group[i]}`, {
            group_id: this.props.match.params.id,
          });
        }
        this.showAlert("Sucesso", "Adicionado com sucesso!");
        setTimeout(function () {
          window.location.reload();
        }, 3000);
      } catch (err) {
        console.log(err);
        this.showAlert("Erro", "Ocorreu um erro ao gravar");
      }
    } else {
      this.showAlert("Erro", "Seleccione pelo menos uma entidade");
    }
  };

  //Criar array de entidades a serem removidas do grupo existente
  arrayRemoveEntities = (event) => {
    const { options } = event.target;
    const value = [];
    for (let i = 0, l = options.length; i < l; i += 1) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }
    this.setState({ remove_from_group: value });
  };

  //Método para remover entidades ao grupo existente
  removeEntitiesFromGroup = (data) => {
    if (data.remove_from_group != null) {
      try {
        for (let i = 0; i < data.remove_from_group.length; i++) {
          this.api.patch(`/entities/${data.remove_from_group[i]}`, {
            group_id: null,
          });
        }
        this.showAlert("Sucesso", "Removido com sucesso!");
        setTimeout(function () {
          window.location.reload();
        }, 3000);
      } catch (err) {
        console.log(err);
        this.showAlert("Erro", "Ocorreu um erro ao gravar");
      }
    } else {
      this.showAlert("Erro", "Seleccione pelo menos uma entidade");
    }
  };

  getEntityGroup() {
    let group_id = this.props.match.params.id;
    //obter o nome do grupo
    this.api.get(`/entity_groups`, { id: group_id }).then(({ data = null }) => {
      this.setState({ entityGroupName: data });
    });
    //obter o grupo de equipamentos e entidades associadas
    this.api
      .get(`/entity_groups`, { group: group_id })
      .then(({ data = null }) => {
        this.setState({ establishmentsList: data });
      });
    //obter so o grupo de entidades(n posso usar o de cima pq repete entidades e p remover n posso ter ids repetidos)
    this.api
      .get(`/entity_groups`, { group_entities: group_id })
      .then(({ data = null }) => {
        this.setState({ entitiesList: data });
      });
  }

  render() {
    return (
      <>
        <div className="main-reqlist-container">
          {this.state.entityGroupName && (
            <Typography
              variant="h6"
              color="#505e6b"
              gutterBottom
              style={{ marginBottom: "20px" }}
            >
              {this.state.entityGroupName[0].name}
            </Typography>
          )}
          <div className="entity-group-table-container">
            <EntityGroupElementsTable
              establishmentsList={this.state.establishmentsList}
            />
          </div>
        </div>

        <div className="main-reqlist-container">
          <Typography
            variant="h6"
            color="#505e6b"
            gutterBottom
            style={{ marginBottom: "20px" }}
          >
            Editar Grupo
          </Typography>
          <div class="mb-2">
            <div class="row mt-4">
              <div class="col-5">
                <Formik
                  initialValues={{ add_to_group: null }}
                  validateOnChange={true}
                  validateOnBlur={true}
                  onSubmit={(values, { setSubmitting }) => {
                    setTimeout(() => {
                      values.add_to_group = this.state.add_to_group;
                      this.addEntitiesToGroup(values);
                      setSubmitting(false);
                    }, 400);
                  }}
                >
                  {({ values, handleSubmit }) => (
                    <form onSubmit={handleSubmit}>
                      <div class="mb-3 font-weight-bold">
                        Lista de entidades
                      </div>
                      {this.state.entities_without_group != null && (
                        <Autocomplete
                          multiple
                          options={this.state.entities_without_group}
                          getOptionLabel={(option) => option.name}
                          onChange={this.arrayAddEntities}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              label="Entidades"
                              fullWidth
                            />
                          )}
                        />
                      )}
                      <Button type="submit">Acrescentar ao grupo</Button>
                    </form>
                  )}
                </Formik>
              </div>

              <div class="col-1"></div>

              <div class="col-5">
                <Formik
                  initialValues={{ remove_from_group: null }}
                  validateOnChange={true}
                  validateOnBlur={true}
                  onSubmit={(values, { setSubmitting }) => {
                    setTimeout(() => {
                      values.remove_from_group = this.state.remove_from_group;
                      //console.log(values.remove_from_group);
                      this.removeEntitiesFromGroup(values);
                      setSubmitting(false);
                    }, 400);
                  }}
                >
                  {({ values, handleSubmit }) => (
                    <form onSubmit={handleSubmit}>
                      {this.state.entityGroupName != null && (
                        <div class="mb-3 font-weight-bold">
                          Entidades do {this.state.entityGroupName[0].name}{" "}
                        </div>
                      )}
                      {this.state.entitiesList != null && (
                        <Select
                          native
                          multiple
                          variant="outlined"
                          onChange={this.arrayRemoveEntities}
                          fullWidth
                          inputProps={{
                            id: "remove_from_group_id",
                          }}
                        >
                          {this.state.entitiesList.map((entity) => (
                            <option key={entity.id} value={entity.id}>
                              {entity.name}
                            </option>
                          ))}
                        </Select>
                      )}
                      <div>
                        <Button type="submit">Remover do grupo</Button>
                      </div>
                    </form>
                  )}
                </Formik>
              </div>
            </div>
            <br />
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(EntityGroupView);
